// External Dependencies:
import React from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import Waypoint from 'react-waypoint'
import YouTubePlayer from 'react-player/lib/players/YouTube'
import VimeoPlayer from 'react-player/lib/players/Vimeo'
import FilePlayer from 'react-player/lib/players/FilePlayer'

// Internal Dependencies:
import { get } from 'utilities/objects'
import LoadingSpinner from 'components/LoadingSpinner/LoadingSpinner'
import PostTileHorImageMedium from 'components/PostTile/PostTileHorImageMedium'
import PostsSectionB from './PostsSectionB'

// Redux:
import { getVideosData, getPageData } from 'actions/page'

class VideosLayout extends React.Component {
	componentDidMount() {
		const { dispatch } = this.props

		dispatch( getVideosData() )

		dispatch(
			getPageData( {
				type: 'posts',
				categorySlug: 'latest',
				number: 1,
				requestOnly: true
			} )
		)
	}

	renderVideo( service, id, fullUrl ) {
		let video,
			url

		if ( id && 'youtube' == service ) {
			url = `https://www.youtube.com/watch?v=${id}`
		} else if ( id && 'vimeo' == service ) {
			url = `https://vimeo.com/${id}`
		} else if ( fullUrl && 'local' == service ) {
			url = fullUrl
		}

		if ( url ) {
			if ( 'vimeo' == service ) {
				video = (
					<VimeoPlayer
						url={ url }
						controls={ true }
					/>
				)
			} else if ( 'youtube' == service ) {
				video = (
					<YouTubePlayer
						url={ url }
						controls={ true }
					/>
				)
			} else if ( 'local' == service ) {
				video = (
					<FilePlayer
						url={ url }
						controls={ true }
					/>
				)
			}
		}

		return video
	}

	renderVideos() {
		const { videosById } = this.props

		if ( ! videosById || Object.keys( videosById ).length < 1 ) {
			return null
		}

		const markup = Object.keys( videosById ).map( ( key ) => {
			let item = videosById[ key ]

			return (
				<div className="video-archive-item" key={ key }>
					<div className="-inner">
						<h2 className="-title">{ item.title }</h2>
						<p className="-date sub">{ item.date.display }</p>

						<div className="-video">
							{ this.renderVideo( item.service, item.id, item.full_url ) }
						</div>
					</div>
				</div>
			)
		})

		return (
			<div className="video-archive">
				{ markup }
			</div>
		)
	}

	render() {
		const { loadingVideos, postsById } = this.props
		const videosMarkup = this.renderVideos()

		const popularPosts = get( [ 'id_latest', 'popular' ] )( postsById ) || {}
		let popularMarkup = null

		popularMarkup = Object.keys( popularPosts ).length ? Object.keys( popularPosts ).slice( 0, 5 ).map( ( key, i ) => {
			let item = popularPosts[ key ]

			return (
				<PostTileHorImageMedium
					key={ key }
					url={ item.url }
					title={ item.title }
					category={ item.category.primary.name }
					author={ item.author }
					date={ item.date.display }
					image={ item.featured_image }
					imageAlt={ item.title }
					number={ i + 1 }
				/>
			)
		}) : false

		return (
			<div>
				<div className="main-inner">
					{ loadingVideos &&
						<LoadingSpinner />
					}

					<div className="wide-sections">
						<div className="category-heading">
							<div className="-inner">
								<h2>Videos</h2>
							</div>
						</div>

						<PostsSectionB primaryMarkup={ videosMarkup } secondaryMarkup={ popularMarkup } />
					</div>
				</div>
			</div>
		)
	}
}

const mapStateToProps = ( state, ownProps ) => {
	return {
		loadingVideos: state.page.loadingVideos,
		videosById: state.page.videosById,
		postsById: state.page.postsById,
		loadingById: state.page.loadingById
	}
}

export default connect( mapStateToProps )( VideosLayout )
